import { ManifestDropdown } from '../../ManifestDropdown';

export const BEDROCK_REGION_OPTIONS = [
  'us-east-1',
  'us-west-2',
  'us-east-2',
  'us-west-1',
  'ca-central-1',
  'eu-central-1',
  'eu-west-2',
  'eu-west-3',
  'eu-west-1',
  'ap-south-1',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-northeast-1',
  'sa-east-1',
  'us-gov-west-1',
];

export const BedrockCommonRegionDropdown = ({
  regionName,
  onChange,
}: {
  regionName: string | null;
  onChange: (regionName: string | null) => void;
}) => (
  <ManifestDropdown<string>
    value={regionName}
    options={BEDROCK_REGION_OPTIONS}
    onChange={onChange}
    placeholder="Select a region..."
  />
);
